import React, { useContext, useEffect } from "react";
import cartContext from "../Context/cartContext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import './payment.css';
import Footer from "../homeComponents/footer";
import Solve from "./payment1";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Payment(){
    const { cart, setCart } = useContext(cartContext);
    const [item,setItem1] = useState(JSON.parse(localStorage.getItem('userCart')));
    const [total, setTotal] = useState({
        currentPrice: 0,
        originalPrice: 0,
        discount: 0
    });

    const navigate = useNavigate();
    // let total = 0;

      useEffect(() => {
        let a = 0;
        let b = 0;
        let c = 0;
        // cart.map((it) => {
        //     a += Number(it.OriginalPrice);
        //     b += Number(it.currentPrice);
        //     c += Number(it.offer);
        // })
        // setItem1();

       item && item.map((it) => {
            a += Number(it.OriginalPrice);
            b += Number(it.currentPrice);
            c += Number(it.offer);
        })
        
        setTotal({ originalPrice: a, currentPrice: b, discount: a - b, });
    }, [cart,item]);
    return (
     <div className="paymentMain">
    <div className="paymentFlex">
        <div className="paymentCard">
         <h1>Add New Card</h1>
         <form onSubmit={(e)=>{
           item && Solve(e)
         }}>
         <h3 className="formHeading">Card Number</h3>
         <input type="number" required className="formInput" name="cardNumber"/>
         <div className="formexpirey">
         <h3 className="formHeading formExpirey">Expiration Date</h3>
         <h5 className="formCvv">CVV</h5>
         </div>
         <div className="formexpirey1">
         <div className="formexpirey">
         <select   className="formDate">
            <option value="Jan (01)">Jan (01)</option>
            <option value="Feb (02)">Feb (02)</option>
            <option value="Mar (03)">Mar (03)</option>
            <option value="Apr (04)">Apr (04)</option>
            <option value="May (05)">May (05)</option>
            <option value="June (06)">June (06)</option>
            <option value="July (07)">July (07)</option>
            <option value="Aug (08)">Aug (08)</option>
            <option value="Sep (09)">Sep (09)</option>
            <option value="Oct (10)">Oct (10)</option>
            <option value="Nov (11)">Nov (11)</option>
            <option value="Dec (12)">Dec (12)</option>
         </select>
         <select  className="formDate">
            <option value='2023'>2023</option>
            <option value='2024'>2024</option>
            <option value='2025'>2025</option>
            <option value='2026'>2026</option>
            <option value='2027'>2027</option>
            <option value='2028'>2028</option>
            <option value='2029'>2029</option>
            <option value='2030'>2030</option>
         </select>
         </div>
         <input type="number" className="formCvvInput"  name="cardCvv" required/>
         </div>
         <input type="checkbox" className="formSaveCard"/>
         <span className="formSaveData">Save this card securely</span>
        <br/>
        <button type="submit" className="formPaymentButton ">Pay {<i class="fa-solid fa-indian-rupee-sign digit"></i>} {total.currentPrice} Securely</button>
        
        <p className="formPaymentText">By placing this order, you agree to AJIO's T&C</p>

         </form>
        </div>
        <div>
        <div className="cartTotal1">
                            <h4 className="orderHeading">Order Summary</h4>
                            <div className="cartOrderDetail">
                                <div>
                                    <h5 className="bagName payment1">Bag Total</h5>
                                    <h5 className="bagName payment1">Bag Discount</h5>
                                    <h5 className="bagName payment1">Delivery Fee</h5>
                                    <h4 className="bagName payment1">Order Total</h4>
                                    <h3 className="bagName payment1">Amount Payable</h3>
                                </div>
                                <div>
                                    <h6>{<i class="fa-solid fa-indian-rupee-sign  digit"></i>} {total.originalPrice}</h6>
                                    <h6 className="cartDiscount">- {<i class="fa-solid fa-indian-rupee-sign  digit"></i>} {total.discount}</h6>
                                    <h6 className="deliveryFees">{<i class="fa-solid fa-indian-rupee-sign  digit"></i>} 99</h6>
                                    <h6>{<i class="fa-solid fa-indian-rupee-sign  digit"></i>} {total.currentPrice}</h6>
                                    <h5>{<i class="fa-solid fa-indian-rupee-sign digit"></i>} {total.currentPrice}</h5>

                                </div>
                            </div>
                            {/* <button className="paymentButton" type="submit" onClick={()=>{
                                navigate('./payment')
                            }}>PROCEED TO PAYMENT</button> */}
                            <ToastContainer />
                        </div>
        </div>
    </div>
    <Footer/>
    </div>
    )
}